import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChartLineIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "ChartLine",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M12.6875 11.375C12.6875 11.491 12.6414 11.6023 12.5594 11.6844C12.4773 11.7664 12.366 11.8125 12.25 11.8125H1.75C1.63397 11.8125 1.52269 11.7664 1.44064 11.6844C1.35859 11.6023 1.3125 11.491 1.3125 11.375V2.625C1.3125 2.50897 1.35859 2.39769 1.44064 2.31564C1.52269 2.23359 1.63397 2.1875 1.75 2.1875C1.86603 2.1875 1.97731 2.23359 2.05936 2.31564C2.14141 2.39769 2.1875 2.50897 2.1875 2.625V7.78586L4.9618 5.35938C5.03729 5.29329 5.1332 5.25516 5.23347 5.25138C5.33373 5.24759 5.43224 5.27839 5.5125 5.33859L8.72867 7.75086L11.9618 4.92188C12.0042 4.87991 12.0547 4.84706 12.1103 4.82534C12.1658 4.80362 12.2252 4.79349 12.2848 4.79557C12.3445 4.79765 12.403 4.8119 12.4569 4.83744C12.5108 4.86298 12.5589 4.89927 12.5983 4.94409C12.6377 4.9889 12.6674 5.04129 12.6858 5.09804C12.7042 5.15479 12.7108 5.2147 12.7051 5.27408C12.6995 5.33346 12.6818 5.39106 12.6531 5.44335C12.6244 5.49564 12.5853 5.5415 12.5382 5.57812L9.0382 8.64062C8.96271 8.70671 8.8668 8.74484 8.76653 8.74862C8.66627 8.75241 8.56776 8.72161 8.4875 8.66141L5.27133 6.25023L2.1875 8.94852V10.9375H12.25C12.366 10.9375 12.4773 10.9836 12.5594 11.0656C12.6414 11.1477 12.6875 11.259 12.6875 11.375Z",
			fill: "currentColor"
		})
	})
});
export default SvgChartLineIcon;
